import React, {Component} from 'react';
import {Link} from 'react-router';

export default class Launch extends Component {
    render(){
        const snBlackLogo = require('images/sn_logo_black.png');

        return(
            <div id='launch'>
                <div className='container'>
                    <img
                        src={snBlackLogo}
                        className='sn-logo' />
                    <div className='gr-12 header-filter'></div>
                    <div className='gr-12 header-launch'>
                        <span className='content-creator-link'>
                            <Link to='/content_creator'>ARE YOU A CONTENT CREATOR?</Link>
                        </span>
                    </div>

                    <div className='gr-12 body-launch'>
                        <Link to='/brand-ambassadors'>
                            <div id='brand-ambassadors-split' className='gr-6'>
                                <div className='brand-ambassadors-text'>
                                    <p>I NEED</p>
                                    <p className='text-emphasis'>SOCIAL</p>
                                    <p>AMBASSADORS</p>
                                </div>
                            </div>
                        </Link>

                        <Link to='/branded-content'>
                            <div id='branded-content-split' className='gr-6'>
                                <div className='branded-content-text'>
                                    <p>I NEED</p>
                                    <p className='text-emphasis'>NATIVE</p>
                                    <p>BRANDED CONTENT</p>
                                </div>

                                
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/pages/launch.js